import { useContext } from 'react';
import { CombinedFeedContext } from '../../../../context/CombinedFeedContext';

// components
import SimplePageSelector from  '@/components/elements/global/PageSelectors/SimplePageSelector';
// import SortByContentDropdown from  '@/components/elements/global/dropdown/SortByContentDropdown';
import BasicButton from  '@/components/elements/global/buttons/BasicButton/BasicButton';
import Information from  '@/components/elements/global/Information';
import NotificationBar from  '@/components/elements/languages/NotificationBar';
import { SimpleTable } from 'thrive-components';
import { AddSourceListExplainer, EditSourceListButtonContent, SavingFeedAsDraft } from  '@/components/elements/combinedFeed/buttons';
import CombinedFeedModal from  '@/components/modals/content/CombinedFeedModal';

// utility and constants
import {listTableColumns} from  '@/components/elements/lists/ListConstants';

//styling
import  '@/css/lists/list.scss';



const CombinedFeed = () => {
    const {contentItems, handleModalOpen, modalOpen, updateListContentItems, paginationSettingsCF, notificationDetails, isLoadingCF, formatCombinedFeedContent, titleError, hasEditorRights, savingContent, hasListId, isLoadingSL} = useContext(CombinedFeedContext);

    return (<>
        <div className={`feed-container`} data-testid="feed">
            {titleError &&  
                <Information text={'You cannot add content to an untitled Combined Feed'} style={undefined} />
            }
            {/* We all know inline styles are bad, but this is a time saving fix, we'll mybe restore the sort in the future */}
            <div className='list-actions-wrapper' style={{justifyContent: 'flex-end'}}>
                {/*<SortByContentDropdown currentSortType={sortType} setSortType={setSortType} isFeed={true} />*/}
   
                {hasEditorRights &&   
                    <BasicButton 
                        className={`source-lists-button ${hasListId && isLoadingSL? "loading-source-lists-button" : ""}`}
                        content={savingContent ? <SavingFeedAsDraft /> : <EditSourceListButtonContent isLoading={hasListId && isLoadingSL} isEdit={contentItems?.length > 0}/> }
                        ariaLabel={modalOpen ? 'Close modal' : 'Add Source Lists'}
                        onButtonClick={() => handleModalOpen(!modalOpen)}
                        isDisabled={savingContent || (hasListId && isLoadingSL)}
                    />
                }
            </div>

            {contentItems?.length > 0
                ?   <SimpleTable 
                        simpleTableContent={{columns: listTableColumns, rows: formatCombinedFeedContent(contentItems)}} 
                        paginationInformation={paginationSettingsCF}
                        isLoading={isLoadingCF}
                        isPaginated={true}
                        isInfiniteScroll={false}
                        isDragAndDrop={false}
                        noDataMessage='No items to display'
                    />
                :   !isLoadingCF && <AddSourceListExplainer />
            }

            {paginationSettingsCF?.hasPagination && 
                <div className='page-selector-wrapper'>
                    <SimplePageSelector
                        currentPage={paginationSettingsCF.currentPage}
                        totalPages={paginationSettingsCF.totalPages}
                        setPage={(page) => {updateListContentItems(page)}}
                    />
                </div>
            }
        </div>

        <CombinedFeedModal />

        <NotificationBar show={notificationDetails.show} notificationStatus={notificationDetails.status} msg={notificationDetails.message} />
    </>)
}

export default CombinedFeed